export default function backToTop() {
  const scrollBtn = document.querySelector('#backtotop');

  if (scrollBtn) {
    window.addEventListener('scroll', function (e) {
      if (window.scrollY >= 200) {
        scrollBtn.classList.add('show');
        scrollBtn.addEventListener('click', () => {
          // console.log('backtotop clicked!');
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        });
      } else {
        scrollBtn.classList.remove('show');
      }
    });
  }
}
